import { money } from "./meta";

const W = 76;
const H = 22;

/** Six closed cycles (line) + this cycle so far (amber dot). */
export function Sparkline({ trend, current, labels, testid }) {
  if (!trend?.length) return null;
  const vals = [...trend, current];
  const max = Math.max(...vals, 0.01);
  const step = W / (vals.length - 1);
  const pts = vals.map((v, i) => [i * step, H - 3 - (v / max) * (H - 6)]);
  const line = pts.slice(0, -1).map(([x, y]) => `${x.toFixed(1)},${y.toFixed(1)}`).join(" ");
  const [lx, ly] = pts[pts.length - 1];
  const [px, py] = pts[pts.length - 2];
  const title = [...trend.map((v, i) => `${labels?.[i] || `Cycle ${i + 1}`}: ${money(v)}`), `This cycle: ${money(current)}`].join("\n");
  return (
    <svg width={W + 4} height={H} viewBox={`-2 0 ${W + 4} ${H}`} className="inline-block align-middle" data-testid={testid}>
      <title>{title}</title>
      <polyline points={line} fill="none" stroke="#0f766e" strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />
      <line x1={px} y1={py} x2={lx} y2={ly} stroke="#f59e0b" strokeWidth="1.2" strokeDasharray="2 2" />
      <circle cx={lx} cy={ly} r="2.4" fill="#f59e0b" />
    </svg>
  );
}
